import React, { useMemo } from 'react';

const KNOWN_EXTENSIONS = [
    'image/png',
    '.png',
    '.jpeg',
    '.pdf',
    'application/pdf',
    '.xls',
    '.xlsx',
    '.csv',
    '.doc',
    '.docx',
];

const FileExtension = ({ isDirectory, extension }) => {
    const tagColor = useMemo(() => {
        switch (extension) {
            case 'image/png':
            case '.png':
            case '.jpeg':
                return 'orange';
            case '.xls':
            case '.xlsx':
            case '.csv':
                return 'green';
            case '.pdf':
                return 'red';
            case '.docx':
            case '.doc':
                return 'blue';
            default:
                return 'transparent';
        }
    }, [extension]);

    if (isDirectory || extension === '') {
        return <p>-</p>;
    }

    if (!KNOWN_EXTENSIONS.includes(extension)) {
        return (
            <div
                style={{ width: 'fit-content' }}
                className="py-1 px-3 rounded-4 border"
            >
                <p
                    className="mb-0"
                    style={{
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    {extension}
                </p>
            </div>
        );
    }

    return (
        <div
            style={{ backgroundColor: tagColor, width: 'fit-content' }}
            className="py-1 px-3 rounded-4"
        >
            <p
                className="mb-0"
                style={{
                    color: 'white',
                    fontSize: 12,
                    fontWeight: 600,
                }}
            >
                {extension}
            </p>
        </div>
    );
};

export default FileExtension;
